<template>
  <div :id="uuid" :style="{width:width+'px',height:height+'px'}"/>
</template>

<script setup>
import {getDataJson, pollingRefresh,hasNonEmptyValues,hasProperty} from "@/utils/refresh-cpt-data";
import {onMounted, watch, computed} from "vue";
import * as echarts from 'echarts'
import { MessagePlugin } from "tdesign-vue-next";

const props = defineProps({
  width:Number,
  height:Number,
  option:Object,
  show:Boolean,
  components:Array,
  current: Object
})
// 新增属性兼容旧代码
const attr = props.option.attribute
if (!attr.globalDataReload) attr.globalDataReload = [0]

let dataReload = computed(() => props.option.attribute.globalDataReload || [0])
watch(() => props.current.cptShow,(val)=>{
    if (val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
  watch(() => props.option.attribute.hideCompInTabw,(val)=>{
    if (!val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
watch(() => props.option.attribute, (obj) => {
  processData(props.option.cptDataForm,newData,jsFunFlag)
  loadChart(obj);
},{deep:true})
watch(() => [props.width,props.height], () => {
  chart.resize()
})

let uuid = require('uuid').v1();
let chartOption = {};
let chart = null
let cptData = [];
let newData = "";
let jsFunFlag = false;
let radius = [['80%', '84%'],['66%', '70%'],['52%', '56%'],['38%', '42%']];
const emit = defineEmits(['clickHandler'])

onMounted(()=>{
  chart = echarts.init(document.getElementById(uuid))
  if (dataReload.value.includes(0)) {
    refreshCptData();
  }
})

function refreshCptData(cptDataForm = props.option.cptDataForm,paras) {
  pollingRefresh(uuid, cptDataForm, () => loadData(cptDataForm,paras),
  props.components)
}
function loadData(cptDataForm,paras) {
  getDataJson(cptDataForm,paras,(res)=> {
          newData = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
        jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
        processData(cptDataForm,newData,jsFunFlag)
        // let parse = res;
        // if (parse.length>4){
        //   MessagePlugin.warning('聚环图数据长度不能大于4')
        // }
        // cptData = parse.slice(0,4);
        loadChart(props.option.attribute);

      })
}
function processData(cptDataForm,res,jsFunFlag){
  let parse;
          // 第一层判断 如果选择数据集
          if(cptDataForm.dataSource == '4') {
            // 第二层判断 ，如果没有配转换脚本
            if(jsFunFlag) { // 没有全部配置映射字段
                if(hasNonEmptyValues(props.option.attribute.cptTableData)) {
                    const dataKey = props.option.attribute.cptTableData;
                     let newarr = [];
                      // 遍历原始数组并重组数据
                        res.forEach(item => {
                          let name = item[dataKey[0].value];
                          let value = item[dataKey[1].value];

                          // 创建新的对象并添加到 aa 数组中
                          newarr.push({ name, value });
                        });
                        console.log(newarr,'新数组')
                        parse = newarr; 
              if (parse && parse.length>4){
                MessagePlugin.warning('聚环图数据长度不能大于4')
              }
              cptData = parse.slice(0,4);
              }
             } else { // 如果配置了转换脚本
              parse = res;
              if (parse && parse.length>4){
                MessagePlugin.warning('聚环图数据长度不能大于4')
              }
             cptData = parse.slice(0,4);
             }
          } else { // 不是数据集类型，是静态数据
              parse = res;
              if (parse && parse.length>4){
                MessagePlugin.warning('聚环图数据长度不能大于4')
              }
             cptData = parse.slice(0,4);
          } 
  }
function loadChart(attr) {
  const colors = attr.color;
  let total = 0;
  let legends = [];
  cptData.forEach(item => {
    total += item.value;
    legends.push(item.name+item.value);
  })
  let pa = '';
  let series = [];
  for (let i = 0; i < cptData.length; i++) {
    const item = cptData[i];
    series.push({
      name:item.name+item.value,
      type:'pie',
      radius: radius[i],//环的位置
      label: {show: false},
      labelLine: {show: false},
      data:[
        {value:item.value,itemStyle: {color: colors[i]}},
        {value:total-item.value, itemStyle: {color: 'transparent'}}
      ],
    });
    const temp = parseFloat((item.value/total*100).toFixed(1));
    pa += ':'+temp
  }
  pa = pa.slice(1);
  chartOption = {
    color:colors,
    // title:{
    //   left:'center',
    //   top:'40%',
    //   text:'占比',
    //   textStyle: {color:'#fff', fontWeight:'normal'},
    //   subtext:pa,
    //   subtextStyle:{color:'#fff'}
    // },
    legend: {
      show: true,
      orient: 'vertical',
      x: attr.legendX+'%',
      y: attr.legendY+'%',
      // itemHeight: attr.legendHeight,
      // itemWidth: attr.legendWidth,
      itemHeight: 0,
      itemWidth: 0,
      itemGap:attr.itemGap,//图例之间的间距
      textStyle: {
        color: attr.legendColor,
        fontSize:attr.legendSize
      },
      itemStyle: {
        color: 'rgba(0,0,0,0)',
      },
      data:legends//图例的名字需要和饼图的name一致，才会显示图例
    },
    series:series,
    tooltip: {
            trigger: 'item',
            backgroundColor: 'rgba(0,0,0,0.5)',
            textStyle: {
                color: "#fff",
            },
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                type: 'shadow',       // 默认为直线，可选为：'line' | 'shadow'
            }
        }
  };

  // chartOption.series.push({
  //   type:'pie',
  //   radius: ['0%','35%'],
  //   label: {show: false},
  //   labelLine: {show: false},
  //   data:[{
  //       value:100,
  //       itemStyle: {color: new echarts.graphic.LinearGradient(
  //             0, 0, 0, 1, [{offset: 0, color: attr.hartColor[0]},{offset: 1, color: attr.hartColor[1]}]
  //       )}
  //   }]
  // });
  chart.setOption(chartOption,true);
  chart.on('click', (params) => {
    emit("clickHandler",props.option.interaction,'default',params.name)
  })
}

defineExpose({refreshCptData})
</script>

<style scoped>

</style>
